export default "__VITE_ASSET__Bo6gPsFV__"